<template>
  <div>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <!-- 卡片-主体-表单-表格数据筛选 -->
        <div class="md-layout card-form" style="max-width: 400px;">
          <!-- 表单-选择框-公司 -->
          <div class="md-layout-item md-size-75 left-layout-item md-xsmall-size-50">
            <md-field>
              <label>{{$I18n("server_type")}}</label>
              <md-select v-model="formData.type">
                <md-option value="__ALL__">{{$I18n("all")}}</md-option>
                <md-option 
                  v-for="item in $Param.srvList" 
                  :value="item.id" 
                  :key="item.id">
                  {{item.name}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-25">
            <md-button class= "left-icon md-info" @click="form_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <add-button @click="() => table_addItem()">{{$I18n("add_setting")}}</add-button>
          </div>
        </div>
        <md-table v-model="tableData">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('id')">{{ item.create_index }}</md-table-cell>
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
            <md-table-cell :md-label="('Key')">{{ item.key }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')"  class="button-box">
              <md-button @click="table_editItem(item)" class="md-just-icon md-round md-info left-icon">
                <md-icon>edit</md-icon>
              </md-button >
              <md-button @click="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info" >
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
    <simple-modal 
      ref        = "modal"
      :title     = "modalTitle"
      :right     = "openModalType!=='delete'"
      :large     = "openModalType==='import'"
      :submitBtn = "openModalType!=='import'"
      @submit    = "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.create_index)}}</div>
        <!-- 修改/添加弹窗 -->
        <div class="md-layout" v-else>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <md-field slot="content" style="border: 1px solid #dddddd;background: #eeeeee;">
              <md-textarea v-model="modalData.Form[item.keys]" style="height: 400px;max-height: unset;"/>
            </md-field>
            <md-field slot="type">
              <md-select v-model="modalDataType" :disabled="openModalType !== 'add'">
                <md-option v-for="item in $Param.srvList" :key="item.id" :value="item.id">{{item.name}}</md-option>
              </md-select>
            </md-field>
          </common-form-item>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      formData  : {type: "__ALL__"},
      searchData: {type: ""},

      // Table 原始数据 (翻页)
      tableInitData: [],
      pageNo   : 1,
      total    : 0,

      // 每页的数量(统一)
      pageSize: 10,
      // 弹窗相关
      openModal     : false, // 是否打开弹窗
      openModalType : "",    // 弹窗类型
      modalTitle    : "",    // 弹窗标题
      // 弹窗表单相关
      modalDataType:"",
      modalData : new FormClass({
        "sys"    : this.userinfo_sys,
        "type"   : this.$Param.srvList[0].id,
        "name"   : "",
        "content": ""
      },{
        "sys"    : val => {
          if(this.openModalType === "add"){
            return !val;
          } 
          return false;
        },
        "type"   : val => {
          if(this.openModalType === "add"){
            return !val;
          } 
          return false;
        },
        "name"   : val => {
          if(this.openModalType === "add"){
            return !val;
          } 
          return false;
        },
        "content": "required",
      }),
    };
  },
  watch: {
    pageNo(){
      this.api_getPageData();
    },
    modalDataType:{
      handler(newValue){
        if(this.openModalType === "edit"){
          return
        }
        this.modalData.Form.type = newValue;
        if(!newValue){
          return
        }
        this.api_getTemp();
      },
      immediate: true,
      deep: true,
    }
  },
  computed:{
    // 表格数据处理
    tableData(){
      return [...this.tableInitData]
        .splice((this.pageNo-1) * this.pageSize, this.pageSize)
        .map(item => {
          return {
            ...item,
            type_name: this.$Param.srvList.getName(item.type),
          }
        })
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          disabled: this.openModalType !== "add",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          required: true,
          check   : true,
          options : this.$Param.srvList.build(),
          disabled: true,
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("content"),
          keys    : "content",
          // type    : "textarea",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-100",
        }
      ]
    },
  },
  mounted(){
    this.api_getPageData();
  },
  methods: {
    api_getTemp(){
      this.$api.getSrvTemp({
        type    : this.modalData.Form.type,
        format  : "yaml",
        content : "",
      })
      .then(this.$Then(res => {
        this.modalData.Form.content = res.data.content;
      }))
      .catch(this.$Catch("",() => {
        this.modalData.Form.content = "";
      }))
    },
    // 查询
    form_search() {
      this.searchData.type = this.formData.type === "__ALL__" ?"" :this.formData.type;
      this.pageNo = 1;
      this.api_getPageData();
    },
    api_getPageData() {
      this.$api.getSrvCfg({
        ...this.searchData,
        sys      : this.userinfo_sys,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.data.length;
        }))

        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 添加
    table_addItem(){
      this.openModalType = "add";
      this.modalData.Reset();
      this.modalDataType = this.$Param.srvList[0].id;
      this.api_getTemp();
      this.modalTitle = this.$I18n("add");
      this.$refs.modal.open();
    },
    // 修改
    table_editItem(item){
      this.openModalType = "edit";
      this.modalDataType = item.type;
      this.modalData.Update(item);
      this.modalTitle = this.$I18n("edit");
      this.$refs.modal.open();
    },
    // 删除
    table_deleteItem(item){
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.modalTitle = this.$I18n("delete");
      this.$refs.modal.open();
    },
    modal_submit(){
      if(this.openModalType === "delete"){ // 删除
        return this.$api.delSrvCfg({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("delete_success"))
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      }
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      if(this.openModalType === "add"){
        this.$api.addSrvCfg({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("add_success"))
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.openModalType === "edit"){
        this.$api.setSrvCfg({...this.modalData.Form,})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("edit_success"))
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>